const routes = [
    {
        path: "/parameters",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "parameter_index"
        }
    },
    {
        path: "/parameter/items/:id",
        component: () => import("../pages/Parameteritem"),
        meta: {
            isAuthenticated: true,
            permission: "parameteritem_index"
        },
    },
];

export default routes;
